import React from 'react';
import { Layout } from 'antd';
import MainHeader from '@/components/mainheader';
import MainFooter from '@/components/mainfooter';
import PageTopbar from '@/components/pagetopbar';
import PageBack from '@/components/pageback';
import usePageBack from '@/utils/usePageBack';
import './index.scss';

// 新业务页面共用桌面内容区与移动端固定返回栏。
const FeaturePage = ({ title, subtitle, back = '/personal', embedded = false, showDesktopBack = true, className = '', children }) => {
  const goBack = usePageBack(back);
  const hasDesktopBack = !embedded || showDesktopBack;
  return <div className={`featurePage ${embedded ? 'featurePage-embedded' : ''} ${className}`}>
    {!embedded && <MainHeader />}
    <PageTopbar className="featurePage-topbar" title={title} onBack={goBack} />
    {hasDesktopBack && <PageBack className="featurePage-back" onBack={goBack} />}
    <Layout.Content className="featurePage-content">
      <div className={hasDesktopBack ? 'pageBack-shell' : undefined}>
        <div className="featurePage-heading"><div><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div></div>
        {children}
      </div>
    </Layout.Content>
    {!embedded && <MainFooter />}
  </div>;
};
export default FeaturePage;
